<template>
  <div class="quick-access-bar">
    <div class="quick-access-grid">
      <button
        v-for="item in items"
        :key="item.key"
        type="button"
        class="quick-access-tile dash-tile dash-focusable"
        :class="{ 'is-disabled': item.disabled }"
        :style="{ '--tile-color': item.color }"
        :disabled="item.disabled"
        :title="item.disabled ? $t('accueil.dashboard.accessDenied') : item.label"
        @click="handleClick(item)"
      >
        <span
          class="quick-access-icon"
          :style="{ backgroundColor: item.color + '1f', color: item.color }"
        >
          <a-icon :type="item.icon" />
        </span>
        <span class="quick-access-label">{{ item.label }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  canUseFeature,
  DASHBOARD_FEATURES,
} from "../utils/dashboardAccess";

export default {
  name: "QuickAccessBar",
  computed: {
    ...mapState(["user", "settings"]),
    items() {
      return [
        {
          key: "cantine",
          label: this.$t("accueil.dashboard.quickCantine"),
          icon: "coffee",
          color: "#1890ff",
          route: "/cantine",
          feature: DASHBOARD_FEATURES.cantine,
        },
        {
          key: "consolidation",
          label: this.$t("accueil.dashboard.quickConsolidation"),
          icon: "cluster",
          color: "#722ed1",
          route: "/",
          feature: null,
        },
        {
          key: "classes",
          label: this.$t("accueil.dashboard.quickClasses"),
          icon: "read",
          color: "#52c41a",
          route: "/etablissement",
          feature: DASHBOARD_FEATURES.etablissement,
        },
        {
          key: "emploi",
          label: this.$t("accueil.dashboard.quickEmploi"),
          icon: "calendar",
          color: "#fa8c16",
          route: "/schedule",
          feature: DASHBOARD_FEATURES.emplois,
        },
        {
          key: "eleves",
          label: this.$t("accueil.dashboard.quickEleves"),
          icon: "user",
          color: "#13c2c2",
          route: "/elevesliste",
          feature: DASHBOARD_FEATURES.eleves,
        },
        {
          key: "discipline",
          label: this.$t("accueil.dashboard.quickDiscipline"),
          icon: "safety-certificate",
          color: "#f5222d",
          route: "/listePunitions",
          feature: DASHBOARD_FEATURES.punition,
        },
        {
          key: "support",
          label: this.$t("accueil.dashboard.quickSupport"),
          icon: "customer-service",
          color: "#eb2f96",
          route: "/",
          feature: null,
        },
      ].map((item) => ({
        ...item,
        disabled: item.feature
          ? !canUseFeature(this.user, this.settings, item.feature)
          : false,
      }));
    },
  },
  methods: {
    handleClick(item) {
      if (item.disabled || !item.route) return;
      if (this.$route.path !== item.route) {
        this.$router.push({ path: item.route });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/components/mixins.scss";

.quick-access-bar {
  margin-bottom: 4px;
}

.quick-access-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 14px;

  @media (max-width: $lg-max-width) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  @media (max-width: $sm-max-width) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.quick-access-tile {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 18px 10px 14px;
  cursor: pointer;
  animation: dash-fade-in-up 0.35s ease both;
  box-shadow: var(--dash-shadow, 0 1px 4px rgba(15, 23, 42, 0.06)) !important;

  &:hover:not(.is-disabled),
  &:focus-visible:not(.is-disabled) {
    transform: translateY(-4px);
    border-color: var(--tile-color, #1890ff);
    box-shadow: var(--dash-shadow, 0 1px 4px rgba(15, 23, 42, 0.06)) !important;

    .quick-access-icon {
      transform: scale(1.08);
    }
  }

  &:active:not(.is-disabled) {
    transform: translateY(-1px) scale(0.98);
  }

  &.is-disabled {
    cursor: not-allowed;
    opacity: 0.45;
    filter: grayscale(0.35);
  }
}

.quick-access-icon {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  transition: transform 0.2s ease;
}

.quick-access-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #262626;
  text-align: center;
  line-height: 1.25;
}

[data-kit-theme="dark"] {
  .quick-access-label {
    color: #aeaee0;
  }
}
</style>
